<template>
    <div class="background" ref="AboutUs">
        <div class="layer">
            <div class="layer2">
                <div class="content">
                    <p class = "title">OUR MISSION</p>
                    <p class = "info">Create Top-notch Live Entertainment & Distinguished Event With Unique Concepts & Great Ideas...</p>
                    <p class = "title">WHO WE ARE</p>
                    <p class = "info">
                        <ul>
                            <li class = "info">
                                LE-TIMES dedicates on top quality entertainment performance and various of themed events creation for decades. Head quarter locates in Beijing.  
                            </li>
                            <li class = "info">
                                LE-TIMES offers most professional services to help clients to create most trendy event, parties, shows ever. <br/>
                                360 services covers live shows, artists incubation & Mgmt. , trendy events incl. operation etc.                          
                            </li>
                            <li class = "info">
                                LE-TIMES has a most energetic, vibrant and young team <br/>
                                -- we aiming to create ultimate entertainment experience for all clients. <br/>
                                -- we making creative concepts and cooperate with most capable artists across China. <br/>
                                -- we promise on high quality and professionalism.
                            </li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      selected: String,
    },
    data() {
      return {
        
      };
    },
    methods: {
      
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
 
    .background{
    height: 100vh;
    width: 100vw;
    background: url(../assets/background.png) no-repeat center center;
    background-size: cover;
    z-index: -1; /* 确保背景位于内容之下 */
    
    }
    .layer{
        background-color: rgba(0,0,0,0.5);
        height: 100vh;
        width: 100vw;
        text-align: center;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .layer2{
        top: 0%;
        position: relative;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .content{
        font-family: Futura, Helvetica, Arial, sans-serif;
        width: 50%;
        overflow: hidden;
        color: white;
        
    }
    .title{
        font-size: 1.5rem;
        line-height: 5rem;
        animation-name: titleAnimation;
        animation-duration: 1s;
        /* animation-timeline: view(); */
    }
    .info{
        line-height: 2rem;
        font-size: 1rem;

    }
    @keyframes titleAnimation {
        0% {
            transform: translateX(-300%);
        }
        to {

        }
    }
    @media (max-width: 768px) {
        .layer2{
            top: 0%;
            position: relative;
            overflow-y: scroll;
        }
        .content{
            width: 80vw;

        }
        .title{
            line-height: 4rem;
        }
        .info{
            line-height: 1.5rem;
        }
    
    
    }
  
  </style>
  